<div class="popup modal-header w-100 d-inline-block  pb-0 mb-0">
   
  <div *ngIf="showNext" class="p-4">
    <div class="text-right w-100" ><fa-icon [icon]="icons.cancel" (click)="bsModalRef?.hide()"    class="icon"></fa-icon></div>
    <img src="assets/images/Success.gif" class="success">

    <h1>Booking Update Request Sent!</h1>
    <p class="mb-5">Your booking Amendment is being processed
      Our support team would get in touch shortly
    </p>
    <div class="mb-4 d-flex  gap-3 resend">
      <button class="btn btn-resend w-100 " (click)="bsModalRef?.hide()">Done</button>
    </div>
  </div>

    <div *ngIf="!showNext">
      <div class="d-flex justify-content-between align-items-center header">
        <p >Edit Contact</p>
        <div class="text-right" ><fa-icon [icon]="icons.cancel" (click)="bsModalRef?.hide()"    class="icon"></fa-icon></div>
      </div>
      
      <form [formGroup]="form" class="p-4 pt-2">
        <div class="row">
          <div class="col-12 form-input">
            <app-input formCtrlName="name" [label]="'Name'" [formGrp]="form" text [required]="true">
            </app-input>
          </div>
    
          
    
          <div class="col-12 form-input mt-2">
            <app-input formCtrlName="email" [label]="'Email address'" [formGrp]="form" text [required]="true">
            </app-input>
          </div>
    
          <div class="col-12 form-input mt-2">
            <!-- <input class="form-control" error="true" required type="tel" placeholder="Phone no" formControlName="phone"> -->
            <app-input formCtrlName="phone" [label]="'Phone number'" [formGrp]="form" text [required]="true">
            </app-input>
          </div>
    
          <textarea formControlName="location" placeholder="Home Address"
            class="form-control booking-text-area text-body mt-3" cols="10" rows="2">Enter home address</textarea>
          <textarea formControlName="message" placeholder="Enter amendment message"
            class="form-control booking-text-area text-body mt-3" cols="10" rows="5">Enter amendment message</textarea>
    
    
    
        </div>
    
        <div class="mt-3 d-flex justify-content-start">
          <app-button (onclick)="onConfirm()" [disabled]="form.invalid" warning> {{loading ? 'Processing...' : 'Update'}} </app-button>
    
        </div>
    
      </form>
      
    </div>
  </div>
  